import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Search from './Search/Search';
import FilterIcons from './filterIcon/FilterIcon';
import Burger from './burger/Burger';
import { NavLink } from 'react-router-dom';
import style from './Header.module.scss'
import Menu from '../box/boxMenu/Menu';
import Filter from '../filter/Filter';
import { fetchMovies } from '../../redux/contentSlices/asyncActions'
import { selectFilter } from '../../redux/filterSlices/FilterSelector'
import { selectHeader } from '../../redux/headerSlices/HeaderSelector'
import { useAppDispatch } from '../../redux/Store';

function Header() {

    const dispatch = useAppDispatch();

    const { filter, burger } = useSelector(selectHeader)

    const search: string = '';

    const { type, sortingBy, minRating, ordering } = useSelector(selectFilter)

    return (
        <header className={style.Header}>
            <div className={style.Header__logo}>
                <NavLink to='/' onClick={() => dispatch(fetchMovies({ type, minRating, sortingBy, ordering, search }))}>
                    <span>MOVIE</span>
                </NavLink>
            </div>
            <Search />
            <div className={style.Header__profile}>
                <FilterIcons />
                <Burger />
            </div>
            {filter ? <Filter /> : null}
            {burger ? <Menu /> : null}
        </header>
    );
}

export default Header;